import { render, staticRenderFns } from "./ShainDetails.vue?vue&type=template&id=486c44ef&scoped=true"
import script from "./ShainDetails.vue?vue&type=script&lang=js"
export * from "./ShainDetails.vue?vue&type=script&lang=js"
import style0 from "./ShainDetails.vue?vue&type=style&index=0&id=486c44ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486c44ef",
  null
  
)

export default component.exports